<template>
  <div class="tradeName">
    <div class="name line-b pb2 fs15">
      <span
        class="csp"
        :class="{ active: activedCategory === item.value }"
        v-for="item in category"
        :key="item.value"
        @click="activedCategory = item.value"
      >
        {{ item.label }}
      </span>
    </div>
    <p class="p1" v-if="activedCategory==='Brand'">按药物英文名的字母顺序排列</p>
    <p class="p1" v-else-if="activedCategory==='Generic'">按通用名英文名的字母顺序排列</p>
    <p class="p1" v-else-if="activedCategory==='Company'">按药商英文名的字母顺序排列</p>
    <p class="p2 wb">
      <span class="csp">ALL#</span>
      <span
        v-for="(item, index) in letters"
        :key="index"
        class="csp"
        :class="`${letter === item ? 'fwb black' : ''}`"
        @click="letter = item"
      >
        {{ item }}
      </span>
    </p>
    <div class="list oa" v-loading="loading" element-loading-spinner="el-icon-loading">
      <div class="item csp" v-for="(item, index) in list" :key="index" @click="go2detail(item)">
        {{ item.showName }}
        <span v-if="item.eFull==='Y'" class="sym ml1 tbc-black ml4">M</span>
        <span v-if="item.TagCloud==='Y'" class="sym ml1 tbc-theme ml2">新产品聚焦</span>
      </div>
    </div>
    <el-pagination
      layout="prev, pager, next"
      v-show="total"
      class="tc mt5"
      :total="total"
      :page-size="limit"
      @current-change="onPageChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'tradeName',
  data() {
    const queries = this.$utils.query2Obj(location.search);
    return {
      activedCategory: queries.category || 'Brand',
      letter: queries.letter || 'A',
      category: [
        { value: 'Brand', label: '药名' },
        { value: 'Generic', label: '通用名' },
        { value: 'Company', label: '药商名' },
      ],
      letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      list: [],
      loading: false,
      page: 1,
      total: 0,
      limit: 30,
      title: "按药商英文名的字母顺序排列"
    };
  },
  computed: {
    params() {
      return { searchBy: this.activedCategory, letter: this.letter, limit: this.limit, page: this.page };
    },
  },
  watch: {
    params: {
      immediate: true,
      deep: true,
      handler() {
        this.getList();
      },
    },
  },
  created() {},
  methods: {
    onPageChange(page) {
      this.page = page;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$apis.drug
        .getDrugList(this.params)
        .then(res => {
          this.list = res.data;
          this.total = res.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    go2detail(item) {
      if (this.activedCategory === 'Company') {
        location.href = `${this.$constants.routers.search.link}?keywords=${encodeURIComponent(item.Name)}&searchType=1&searchBy=Company`;
      } else {
        location.href = `${this.$constants.routers.drugInfo.link}?safeUrl=${encodeURIComponent(item.safeUrl)}&cfrom=${
          item.cfrom
          }`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "../../assets/css/public.css";
.tradeName {
  margin-top: 30px;
  .name {
    color: #333;
    font: 700 20px '';
    span {
      margin-right: 100px;
      &.active {
        color: #eb1b23;
      }
    }
  }
  p {
    font: 14px '';
    &.p1 {
      color: #000;
      margin-top: 28px;
    }
    &.p2 {
      color: #878787;
      margin-top: 15px;
      line-height: 28px;
      span {
        margin-right: 24px;
        &:nth-child(1) {
          font-weight: bold;
        }
      }
    }
  }

  .list {
    margin-top: 10px;
    // max-height: 90vh;
    .item {
      font: 14px/22px '';
      color: #878787;
    }
  }
}
</style>
